import { PropsWithChildren } from "react";
import { TitleProps } from "../types";
import { getTitleStyles } from "../helpers";
import { PolymorphicComponent } from "@/src/components/PolymorphicComponent";

export function Title({
  as = "h1",
  name,
  children,
  className,
  md,
  ...props
}: PropsWithChildren<TitleProps>) {
  return (
    <PolymorphicComponent
      as={as}
      className={getTitleStyles({ className, name, md })}
      {...props}
    >
      {children}
    </PolymorphicComponent>
  );
}
